// eslint-disable-next-line import/extensions
import './polyfills';
import React from 'react';
import {createRoot} from 'react-dom/client';
import * as Sentry from '@sentry/react';
import analyticsService from './analyticsService';
import App from './App';
import '@frontend/ui-kit/index.css';
import {ROOT, SENTRY_DSN, ENV, SEGMENT_KEY} from './constants';
import './index.scss';

if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.0,
        environment: ENV
    });
}

// analytics initialization
analyticsService.load(SEGMENT_KEY);

const root = createRoot(ROOT!);
root.render(<React.StrictMode><App/></React.StrictMode>);
